import { makeActionCreator } from '@/Util/ReduxUtils'

export const RESET_STATE = 'REST_OPERATIONS_STATE'
export const cleanOperations = makeActionCreator(RESET_STATE, 'params')
